import {ApolloClient, InMemoryCache} from '@apollo/client';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

const baseUrl = '__EDLINK_BASE_URL__';

export const customerClient = new ApolloClient({
    uri: baseUrl + '/graphql/customer',
    cache: new InMemoryCache(),
});

export const pwaClient = new ApolloClient({
    uri: baseUrl + '/graphql/pwa',
    cache: new InMemoryCache(),
});

export const publicClient = new ApolloClient({
    uri: baseUrl + '/graphql/public',
    cache: new InMemoryCache(),
});

export const uploadingCustomerClient = new ApolloClient({
    uri: baseUrl + '/graphql/customer',
    cache: new InMemoryCache(),
    link: createUploadLink({uri: baseUrl + '/graphql/customer'}),
});
